export const getMainnetURI = (): string => {
    return "https://api.avax.network/ext/bc/C/rpc";
};
